import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RegisteredAddress } from "../../../domain/entities/all-deliveries";
import { type AllDeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listAddresses = createAsyncThunk<
  RegisteredAddress[],
  string,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_ADDRESSES, async (requestId, { extra }) => {
  return await extra.allDeliveriesRepo.listAddresses(requestId);
});
